import { UserNav } from "./user-nav";
import { SheetMenu } from "./sheet-menu";
// import { ModeToggle } from "../mode-toggle";
import { useSidebarToggle } from "../../hooks/use-sidebar-toggle";
import { useStore } from "zustand";
import Icon from "../../assets/images/Frame 2.svg";

export function Navbar() {
  const sidebar = useStore(useSidebarToggle, (state) => state);

  return (
    <header className="sticky top-0 z-10 w-full bg-sidebar shadow backdrop-blur border-b border-border">
      <div className="mx-4 sm:mx-8 flex h-14 items-center">
        <div className="flex items-center space-x-4 lg:space-x-0">
          <SheetMenu />
        </div>
        <div className="flex flex-1 items-center space-x-2 justify-end">
          {/* <ModeToggle /> */}
          <UserNav />
        </div>
      </div>
    </header>
  );
}
